import React, { ChangeEvent, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { toast } from 'react-toastify'
import Select from 'react-select'
import { ISelectOption } from '../../../../types/IClassifier'
import LoadingSpinner from '../../../../components/LoadingSpinner'
import FormModal from '../../../../shared/components/FormModal'

const reasonSelectOptions: ISelectOption[] = [
  {
    value: '002',
    label: '002 - Invalidation request',
  },
  {
    value: '003',
    label: '003 - Request for time-limit extension',
  },
  {
    value: '004',
    label: '004 - Error notification response; I do not see the same need to amend the declaration details',
  },
  {
    value: '007',
    label: '007 - Bill of discharge / notification of discharge',
  },
  {
    value: '008',
    label: '008 - Notification on re-export of temporary importation or placing under other customs procedure (OSI)',
  },
  {
    value: '010',
    label: '010 - Response for hearing request, approval of the proposal',
  },
  {
    value: '011',
    label: '011 - Cancellation request for the final settlement / notification of the termination of the procedure',
  },
]

interface FinlandContactFormProps {
  show: boolean
  onClose: () => void
  onSubmit: (data: {
    notificationDescription: string
    notificationReason: string
  }) => void
  isSubmitting: boolean
  isError: boolean
}

interface ContactFormProps {
  reason: string
  description: string
}

function FinlandContactFormModal(
  {
    show,
    onClose,
    onSubmit,
    isSubmitting,
    isError,
  }: Readonly<FinlandContactFormProps>,
) {
  const [form, setForm] = useState<ContactFormProps>({
    reason: '',
    description: '',
  })

  const { t } = useTranslation()

  const submitForm = () => {
    if (form.description === '' || form.reason === '') {
      toast.error('Description and reason are mandatory!')
      return
    }
    onSubmit({
      notificationDescription: form.description,
      notificationReason: form.reason,
    })
  }

  useEffect(() => {
    if (isError) {
      toast.error('Error occurred when contacting Finland customs')
    }
  }, [isError])

  return (
    <FormModal show={show} title={t('declaration.p5.contactForm')} onClose={onClose}>
      <div className="d-flex flex-column align-self-center w-100">
        <Select
          placeholder={t('declaration.p5.notificationReason')}
          options={reasonSelectOptions}
          className="select w-100 mb-4"
          classNamePrefix="select"
          menuPlacement="auto"
          value={reasonSelectOptions.find((option) => option.value === form.reason) ?? null}
          onChange={(option: ISelectOption | null) => {
            setForm({
              ...form,
              reason: option?.value,
            })
          }}
          isClearable
          isSearchable={false}
        />
      </div>
      <div className="d-flex flex-column align-self-center w-100 mb-1">
        <textarea
          placeholder={t('declaration.p5.notificationDescription')}
          className="w-100 form-control mb-2"
          onChange={(e: ChangeEvent<HTMLTextAreaElement>) => setForm({
            ...form,
            description: e.target.value,
          })}
        />
      </div>
      <div className="d-flex align-content-end justify-content-end mt-5">
        <button
          type="button"
          className="btn btn-lg btn-primary mx-1 text-secondary shadow-sm"
          onClick={submitForm}
          disabled={isSubmitting}
        >
          {
            isSubmitting && <LoadingSpinner />
          }
          {
            !isSubmitting && (<span>{t('notes.submit')}</span>)
          }
        </button>
      </div>
    </FormModal>
  )
}

export default FinlandContactFormModal
